export const css = {
	root: '_2x7T3ILT',
	heading: 'jfkwYKDA',
	row: '_3H1XF5Kd',
	product: '_3uBoVZUj',
	primary: '_37MDbvbX',
	secondary: 'OsNCHwKv',
	sticky: '_3RNLaQth',
	leading: '_3fTAxrNw',
	title: 'v12-PszX',
	actions: 'WZ0FlSIU',
	trailing: '_1kFQ2wfF',
	spacer: '_1tpkKxLn',
	hamburgerWrapper: 'MwZrDTsC',
	hamburger: '_1xBTK-rV',
	hamburgerText: '_3WB9E-aT',
	hamburgerMenu: '_21bvsw0X',
	hamburgerMenuItem: '_2fq1Ldr3',
	quizSelect: '_2LlvwIdJ',
	quizSelectBlock: 'nGFiurdC',
	hideCountdownBlock: '_1VN9U_7t',
	quizSelectChoice: '_3KfS7wZ_',
	quizSelectHidden: 'xonrlA2G',
	examCalendar: '_1T_eXuAB',
	home: '_2AsZ3sGo',
	selectFadeOut: '_3wDpj3Bw',
	' _key': 'ascm-theme/ascm/lcc-app/heading'
};

export default css;
